import { NavLink as RouterLink } from "react-router-dom";
import {
  AppBar,
  Box,
  Container,
  Divider,
  List,
  ListItem,
  Stack,
  SwipeableDrawer,
  Toolbar,
  Typography,
  useTheme,
} from "@mui/material";
import Logo from "../features/process/components/Logo";
import Language from "./mode/Language";
import { useTranslation } from "react-i18next";
import { ShadowStyled } from "../features/home/styles/layoutStyled";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBars } from "@fortawesome/free-solid-svg-icons";
import { useState } from "react";
import { MenuButton } from "../features/home/styles/componentStyled";
import Mode from "./mode/Mode";
//import { useAppDispatch } from "../app/hooks";
const iOS = process.browser && /iPad|iPhone|iPod/.test(navigator.userAgent);
const MainNavbar = () => {
  // const dispatch = useAppDispatch();
  const theme = useTheme();
  const { t } = useTranslation("auth");
  const { t: tt } = useTranslation();
  const [drawerOpen, setDrawerOpen] = useState(false);
  const handleDrawerOpen = () => {
    setDrawerOpen(!drawerOpen);
  };
  return (
    <>
      <AppBar elevation={0}>
        <Box
          sx={{
            // background: `linear-gradient(to right, ${theme.palette.primary.main} 30%, ${theme.palette.secondary.main} 70%)`,
            backgroundColor: "transparent",
          }}
        >
          <ShadowStyled>
            <Toolbar sx={{ height: 64 }}>
              <Container maxWidth="lg">
                <Stack direction="row" alignItems="center">
                  <RouterLink to="/" data-aos="fade-right">
                    <Logo />
                  </RouterLink>
                  <Typography
                    data-aos="fade-left"
                    variant="h3"
                    noWrap
                    sx={{
                      fontWeight: 900,
                      fontFamily: "Open Sans",
                      p: 0.5,
                      display: { xs: "none", md: "flex" },
                      textTransform: "capitalize",
                    }}
                  >
                    {tt("platform")}
                  </Typography>
                  <Box sx={{ flex: "1 1 auto" }} />
                  <Stack
                    spacing={2}
                    sx={{
                      display: { md: "flex", xs: "none" },
                      flexWrap: "wrap",
                      "& > :not(style)": {
                        m: 0,
                        ml: 2,
                      },
                    }}
                    direction="row"
                  >
                    <Mode />
                    <Language />
                  </Stack>

                  <Stack sx={{ mr: 2, display: { md: "none", xs: "block" } }}>
                    <Box
                      style={{
                        borderRadius: "50%",
                      }}
                      onClick={handleDrawerOpen}
                    >
                      <FontAwesomeIcon icon={faBars} />
                    </Box>
                  </Stack>
                </Stack>
              </Container>
            </Toolbar>
          </ShadowStyled>
        </Box>
      </AppBar>

      <SwipeableDrawer
        disableBackdropTransition={!iOS}
        disableDiscovery={iOS}
        variant="temporary"
        onClose={handleDrawerOpen}
        open={drawerOpen}
        onOpen={handleDrawerOpen}
        anchor="right"
        ModalProps={{
          keepMounted: true, // Better open performance on mobile.
        }}
        sx={{
          display: { xs: "block", md: "none" },
          "& .MuiDrawer-paper": { boxSizing: "border-box", width: 240 },
        }}
      >
        <Box
          sx={{
            // background: `linear-gradient(to bottom, ${theme.palette.primary.main} 30%, ${theme.palette.secondary.main} 90%)`,
            backgroundColor: "primary.main",
            minHeight: "100vh",
          }}
        >
          <Toolbar>
            <RouterLink to="/" data-aos="fade-right">
              <Logo />
            </RouterLink>
            <Typography
              data-aos="fade-left"
              variant="h3"
              noWrap
              sx={{
                fontWeight: 900,
                fontFamily: "Open Sans",
                p: 0.5,
                // display: { xs: "none", md: "flex" },
                textTransform: "capitalize",
              }}
            >
              {tt("platform")}
            </Typography>
          </Toolbar>
          <Divider />
          <List onClick={handleDrawerOpen}>
            <ListItem
              sx={{
                display: "flex",
                p: "6px 16px",
              }}
            >
              <Mode />
            </ListItem>
            <ListItem
              sx={{
                display: "flex",
                p: "6px 16px",
              }}
            >
              <Language />
            </ListItem>
          </List>
        </Box>
      </SwipeableDrawer>
    </>
  );
};

export default MainNavbar;
